var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_instagram") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "6.71416922%",
    y1: "93.4850191%",
    x2: "93.6081727%",
    y2: "6.61873642%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDD55",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF543E",
    offset: "50%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C837AB",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI-Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1_Landing-page",
    transform: "translate(-627, -6763)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(0, 6401)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_instagram",
    transform: "translate(627, 362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.56551283,1.66624741 C-0.315068752,3.61923571 0.069822282,5.69384962 0.069822282,11.9964489 C0.069822282,17.2303379 -0.843546078,22.477187 3.9366809,23.7123849 C5.42938007,24.0962034 18.655273,24.0962034 20.1459779,23.710391 C22.1362435,23.1969714 23.7555778,21.5829397 23.97694,18.7686028 C24.0078509,18.3758119 24.0078509,5.62406443 23.9759428,5.22329807 C23.7406208,2.22552583 21.8949387,0.497843994 19.4629459,0.147921129 C18.9055519,0.0671696985 18.7938737,0.0432433488 15.9341133,0.0382586926 C5.79034005,0.0432433488 3.56674678,-0.408366503 1.56551283,1.66624741 Z",
    id: "Path",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0333524,3.16762586 C8.41278414,3.16762586 4.97469014,2.84561706 3.66147384,6.21524466 C3.11903674,7.60696067 3.19780978,9.41439701 3.19780978,12.0024305 C3.19780978,14.2734399 3.1250195,16.4078697 3.66147384,17.7886194 C4.97169876,21.1602409 8.43771232,20.8372352 12.0313581,20.8372352 C15.4983688,20.8372352 19.0730692,21.1981243 20.4022396,17.7886194 C20.9456738,16.3829464 20.8659036,14.6024272 20.8659036,12.0024305 C20.8659036,8.55105455 21.0563549,6.32291323 19.3821786,4.65006261 C17.6870626,2.9552795 15.3946676,3.16762586 12.0293639,3.16762586 L12.0333524,3.16762586 Z M11.2416335,4.75972505 C18.7938737,4.74776187 19.7551041,3.90834577 19.2246325,15.5694505 C19.0361755,19.693755 15.8952254,19.2411482 12.0343495,19.2411482 C4.99463268,19.2411482 4.7922159,19.0397681 4.7922159,11.9984428 C4.7922159,4.87536907 5.35060703,4.76371277 11.2416335,4.75773118 L11.2416335,4.75972505 Z M16.7497632,6.2262109 C16.1644497,6.2262109 15.6898172,6.70075017 15.6898172,7.28594881 C15.6898172,7.87114745 16.1644497,8.34568672 16.7497632,8.34568672 C17.3350768,8.34568672 17.8097093,7.87114745 17.8097093,7.28594881 C17.8097093,6.70075017 17.3350768,6.2262109 16.7497632,6.2262109 L16.7497632,6.2262109 Z M12.0333524,7.46539643 C9.52757216,7.46539643 7.4964244,9.4971423 7.4964244,12.0024305 C7.4964244,14.5077187 9.52757216,16.5384676 12.0333524,16.5384676 C14.5391326,16.5384676 16.5692832,14.5077187 16.5692832,12.0024305 C16.5692832,9.4971423 14.5391326,7.46539643 12.0333524,7.46539643 Z M12.0333524,9.05749562 C15.9271334,9.05749562 15.9321191,14.9473654 12.0333524,14.9473654 C8.14056846,14.9473654 8.1345857,9.05749562 12.0333524,9.05749562 Z",
    id: "Shape",
    fill: "#FFFFFF"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcInstagram);
export default __webpack_public_path__ + "static/media/ic_instagram.2a47fd469a80885dfc607eded2309acc.svg";
export { ForwardRef as ReactComponent };